import React from 'react'
import './styles.scss'

interface Props {
  children: JSX.Element | string
}

export const SegmentHeadline = ({ children }: Props) => (
  <div className='SegmentHeadline'>{children && children}</div>
)
